import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import RadioPlayer from "../components/RadioPlayer";
import ArtistInfo from "../components/ArtistInfo";
import RecentlyPlayed from "../components/RecentlyPlayed";
import NewsFeed from "../components/NewsFeed";
import WeatherWidget from "../components/WeatherWidget";
import HistoryFacts from "../components/HistoryFacts";
import Top40Chart from "../components/Top40Chart";

const Home = () => {
  return (
    <div>
      {/* HERO */}
      <section className="relative overflow-hidden">
        <div className="absolute -top-40 -left-32 h-[32rem] w-[32rem] rounded-full bg-white/25 blur-3xl" />
        <div className="absolute top-24 right-0 h-[28rem] w-[28rem] rounded-full bg-[#5AA6FF]/40 blur-3xl" />

        <div className="relative mx-auto grid max-w-6xl items-center gap-8 px-5 sm:px-8 pt-28 pb-12 lg:grid-cols-2 lg:items-start lg:gap-14 lg:pt-40 lg:pb-16">
          <div className="min-w-0 text-center lg:text-left animate-fade-up">
            <h1 className="font-heading text-5xl font-extrabold leading-[1.05] text-white sm:text-6xl lg:text-7xl">
              Luister naar<br />
              <span className="bg-gradient-to-r from-white to-[#DCEBFF] bg-clip-text text-transparent">All-In Radio</span>
            </h1>
            <div className="mt-8 flex flex-wrap items-center justify-center gap-4 lg:justify-start">
              <Link to="/luisterlinks" className="inline-flex items-center gap-2 rounded-full bg-white px-6 py-3.5 text-sm font-bold text-[#1E6BE6] shadow-lg shadow-blue-900/10 transition-transform hover:scale-105">
                Alle luisterlinks <ArrowRight className="h-4 w-4" />
              </Link>
            </div>
          </div>

          <div className="mx-auto w-full min-w-0 max-w-md lg:max-w-none lg:pl-6">
            <div className="animate-float-slow">
              <RadioPlayer />
            </div>
            <div className="mx-auto mt-5 max-w-md">
              <ArtistInfo />
            </div>
            <div className="mx-auto mt-5 max-w-md">
              <RecentlyPlayed />
            </div>
          </div>
        </div>
      </section>

      {/* NEWS (Omroep Gelderland - lokaal) */}
      <NewsFeed />

      {/* WEATHER (Nijmegen, ververst 1x per dag) */}
      <WeatherWidget />

      {/* DAILY HISTORICAL FACTS */}
      <HistoryFacts />

      {/* DUTCH TOP 40 - top 3 */}
      <Top40Chart />
    </div>
  );
};

export default Home;
